<dialog-gala (clickClose)="hideRfModal()">
  <span gala-dialog-titre>{{lgTrad.AFFSRFC}}</span>
  <form [formGroup]="formAjout" autocomplete="off">
    <div class="row">
      <div class="col-md-12">
        <select-gala formControlName="RFSURFACE" [options]="data" bindLabel="LBLSURFACE" container="#surfaces"
          [label]="lgTrad.SURFACES" [disabled]="!droitsAccess.write" />
        </div>
      </div>
    </form>
    <div gala-dialog-actions>
      @if (droitsAccess.write) {
        <button mat-stroked-button color="primary" (click)="addSurface()"
        >{{lgTrad.ENR}}</button>
      }
      <button mat-stroked-button color="accent" (click)="hideRfModal()">{{lgTrad.RET}}</button>
    </div>
  </dialog-gala>